// src/utils/getEnv.ts
export const getEnv = (key: string): string | undefined => {
  try {
    // @ts-ignore – this allows import.meta.env in ESM without breaking CJS
    if (
      typeof import.meta !== "undefined" &&
      import.meta.env &&
      import.meta.env[key]
    ) {
      // @ts-ignore
      return import.meta.env[key];
    }
  } catch {
    // Swallow any errors from environments where import.meta doesn't exist
  }
  if (typeof process !== "undefined" && process.env && process.env[key]) {
    return process.env[key];
  }
  return undefined;
};
